import React, { FC } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { UseFormReturn } from 'react-hook-form';
import { TextInputController } from '../InputControllers/TextInputController';
import { CheckboxController } from '../InputControllers/CheckboxController';
import { IProductToolPayload } from '../../resources/api/apiProductTool';
import { HiddenSubmit } from '../HiddenSubmit/HiddenSubmit';
import { useTranslation } from 'react-i18next';

interface IProps {
  form: UseFormReturn;
  onSubmit: (payload: IProductToolPayload) => void;
}

export const ProductToolForm: FC<IProps> = ({ onSubmit, form }) => {
  const { t } = useTranslation();

  return (
    <Grid component="form" container onSubmit={form.handleSubmit(onSubmit)}>
      <Grid item xs={12}>
        <TextInputController
          control={form.control}
          errors={form.formState.errors}
          label={t('adminProducts.tools.form.name')}
          name="name"
          rules={{ required: true }}
        />
      </Grid>
      <Grid item xs={12}>
        <CheckboxController
          control={form.control}
          errors={form.formState.errors}
          label={t('adminProducts.tools.form.isAddon.label')}
          name="isAddon"
        />
        <Typography variant="caption" display="block">
          {t('adminProducts.tools.form.isAddon.helper')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <CheckboxController
          control={form.control}
          errors={form.formState.errors}
          label={t('adminProducts.tools.form.archived.label')}
          name="archived"
        />
        <Typography variant="caption" display="block">
          {t('adminProducts.tools.form.archived.helper')}
        </Typography>
      </Grid>
      <HiddenSubmit />
    </Grid>
  );
};
